import classNames from "classnames";
import { PropsWithClassName } from "shared/props";
import { AdvangateViewModel, AllAdvantages } from '../model/advantages'

import styles from './advantages.module.scss';

export interface AdvantagesProps {
	isFree: boolean;
}

export const Advantages = (props: AdvantagesProps & PropsWithClassName) => {
	return (
		<ul className={classNames(props.className, styles.container)}>
			{ AllAdvantages.map((item, index) => <Advantage key={index} item={item} isFree={props.isFree} />) }
		</ul>
	)
}

interface AdvantageProps {
	item: AdvangateViewModel;
	isFree: boolean;
}
const Advantage = (props: AdvantageProps) => {
	const isIncluded = props.item.isFree || !props.isFree;
	if (!isIncluded)
		return null;

	return (
		<li className={classNames(styles.item)}>
			<i className={classNames('fa', isIncluded ? styles.included : styles.excluded, styles.mark)}></i>
			<span>{ props.item.content }</span>
		</li>
	)
}